<p-blockUI #pnl [blocked]="blocked">
    <div class="ui-g"
        style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;margin: auto;width:100px;height: 100px;">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
            <i class="pi pi-spin pi-spinner" style="color:white; margin: 0 auto;font-size: 5rem"></i>
        </div>
        <br>
        <div class="ui-g-12 ui-md-12 ui-lg-12" style="color:white; margin: 0 auto;">
            <strong>Procesando</strong>
        </div>
    </div>
</p-blockUI>

<div class="init">
    <section>
        <div class="container">
            <div class="div">
                <div class="imgBx">
                    <img [src]="logobox" alt="">
                </div>
                <br>
                <div class="contentBx">
                    <div class="div-logo">
                        <img [src]="logo" class="logito" alt="Finance Web" />
                    </div>
                    <div class="formBx" *ngIf="verLogin">
                        <h4 *ngIf="!usuario.cambioclave">Ingrese a su Cuenta</h4>
                        <h4 *ngIf="usuario.cambioclave">Modificar Contraseña</h4>
                        <form>
                            <div class="form-group" *ngIf="dtoConfiguracionLogin.verUsuario"><label for="email">Usuario</label>
                                <div class="input-icon icon-username"></div><input autofocus="true" class="form-control"
                                    [(ngModel)]="usuario.usuario"
                                    (ngModelChange)="usuario.usuario = $event.toUpperCase()"
                                    (blur)="cargarCompaniasPorUsuario()" [ngModelOptions]="{standalone:true}" id="email"
                                    name="email" placeholder="Ingrese su usuario" type="text">
                            </div>
                            <div class="form-group" *ngIf="dtoConfiguracionLogin.verContrasenia"><label *ngIf="!usuario.cambioclave"
                                    for="password">Contraseña</label> <label *ngIf="usuario.cambioclave"
                                    for="password">Contraseña actual</label>
                                <div class="input-icon icon-password"></div>
                                <input *ngIf="!usuario.cambioclave" autocomplete="off" class="form-control password"
                                    id="password" name="password" [(ngModel)]="usuario.clave"
                                    [ngModelOptions]="{standalone:true}" placeholder="Ingrese la contraseña"
                                    type="password">

                                <input *ngIf="usuario.cambioclave" autocomplete="off" class="form-control password"
                                    id="password" name="password" [(ngModel)]="usuario.clave"
                                    [ngModelOptions]="{standalone:true}" placeholder="Ingrese la contraseña actual"
                                    type="password">
                            </div>
                            <div *ngIf="usuario.cambioclave" class="form-group"><label for="password">Nueva
                                    contraseña</label>
                                <div class="input-icon icon-password"></div>
                                <input autocomplete="off" class="form-control password" id="password" name="password"
                                    [(ngModel)]="usuario.nuevaclave" [ngModelOptions]="{standalone:true}"
                                    placeholder="Ingrese la nueva contraseña" type="password">
                            </div>
                            <div *ngIf="!usuario.cambioclave&&dtoConfiguracionLogin.verCompania" class="form-group"><label for="password">Compañía</label>

                                <p-dropdown [options]="companias" [(ngModel)]="usuario.companiaCodigo"
                                    [ngModelOptions]="{standalone:true}"
                                    [style]="{'width':'100%','height':'40px', 'margin-bottom':'20px', 'text-align':'left'}">
                                </p-dropdown>
                            </div>
                            <div class="inputBx" *ngIf="dtoConfiguracionLogin.verIngresar">
                                <input type="submit" value="Ingresar" (click)="login()">
                            </div>
                            <div class="inputBx" *ngIf="dtoConfiguracionLogin.verIngresarAzureAD">
                                <button (click)="loginAD()"
                                    style="background: #128C7E;color: #fff;outline: none;font-weight: 600;cursor: pointer;border-radius: 30px;width: 100%;padding: 10px 20px;font-size: 16px;letter-spacing: 1px;">
                                    Ingresar con Azure AD
                                </button>
                            </div>
                            <div class="inputBx">
                                <p-checkbox [ngModelOptions]="{standalone:true}" binary="true" *ngIf="dtoConfiguracionLogin.verModificarContrasenia"
                                    [(ngModel)]="usuario.cambioclave" inputId="binary">
                                </p-checkbox>
                                &nbsp;<label *ngIf="dtoConfiguracionLogin.verModificarContrasenia" class="label-cambioclave" for="ny">Modificar Contraseña </label>



                                <p *ngIf="dtoConfiguracionLogin.verOlvidasteContrasenia"><br><a style="cursor:pointer;text-decoration: underline;" href="javascript:void(0)"
                                        (click)="recuperarclave()"> ¿Olvidaste tu contraseña?</a></p>

                            </div>

                        </form>
                    </div>

                    <div class="formBx" *ngIf="verRecuperarClave">
                        <h4>Restablecer la contraseña</h4>
                        <form>
                            <p class="overview">Ingrese su usuario y le enviaremos un correo con una contraseña
                                temporal.</p>
                            <div class="form-group"><label for="email">Usuario</label>
                                <div class="input-icon icon-username"></div><input autofocus="true" class="form-control"
                                    [(ngModel)]="correo" (ngModelChange)="correo = $event.toUpperCase()" id="email"
                                    name="email" placeholder="Usuario" type="text">
                            </div>

                            <div class="inputBx">
                                <input type="submit" value="Enviar" (click)="enviarClave()">
                            </div>
                            <div class="inputBx">
                                <p><a style="cursor:pointer" href="javascript:void(0)" (click)="salir()">Cancelar</a>
                                </p>
                            </div>
                        </form>
                    </div>

                    <div class="formBx" *ngIf="verGenerandoToken">
                        <h4>Ingresando por Active Directory</h4>
                        <p>{{profile?.displayName}}</p>
                        <p>{{profile?.userPrincipalName}}</p>
                    </div>

                </div>
            </div>

        </div>

    </section>

</div>